import { useCallback } from 'react'

export function useAiAskBarDictationActions({
  finalizeSession,
  onDictationSessionEnd,
  setIsDictating,
}) {
  const handleDictationConfirm = useCallback(async () => {
    const audioBlob = await finalizeSession(true)
    await onDictationSessionEnd?.({ reason: 'confirm', audioBlob })
    setIsDictating(false)
  }, [finalizeSession, onDictationSessionEnd, setIsDictating])

  const handleDictationCancel = useCallback(async () => {
    await finalizeSession(false)
    await onDictationSessionEnd?.({ reason: 'cancel' })
    setIsDictating(false)
  }, [finalizeSession, onDictationSessionEnd, setIsDictating])

  return { handleDictationConfirm, handleDictationCancel }
}
